var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.146,
    height: 24,
    viewBox: "0 0 18.146 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 2.158,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ca2cc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_2_",
    "data-name": "user (2)",
    transform: "translate(-4.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21064",
    "data-name": "Path 21064",
    d: "M12.811,1.25a5.561,5.561,0,1,0,5.561,5.561A5.561,5.561,0,0,0,12.811,1.25Zm-3.8,5.561a3.8,3.8,0,1,1,3.8,3.8A3.8,3.8,0,0,1,9.006,6.811Z",
    transform: "translate(0.512 0)",
    fillRule: "evenodd",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21065",
    "data-name": "Path 21065",
    d: "M9.811,12.25a5.561,5.561,0,1,0,0,11.122h7.024a5.561,5.561,0,0,0,0-11.122Zm-3.8,5.561a3.8,3.8,0,0,1,3.8-3.8h7.024a3.8,3.8,0,1,1,0,7.61H9.811A3.8,3.8,0,0,1,6.006,17.811Z",
    transform: "translate(0 1.878)",
    fillRule: "evenodd",
    fill: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e0b4d84b401e42180d2707a8812f22a3.svg";
export { ForwardRef as ReactComponent };